import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { StartAssessmentBase } from "../StartAssessmentBase";

/**
 * Start an training session.
 */
export const StartTraining = () => (<StartAssessmentBase defaultAssessmentType={AssessmentType.TrainingModule} />);
